import { CompanyMergeData } from '../../data/company.merge.data';

export class FakeCompanyMergeData extends CompanyMergeData {

    constructor(baseUrl: string = '') {
        super();

        this._id = '0c573a9a-a442-4d40-865b-b2225e13b41d';
        this.name = 'WorkBuddy Construction';
        this.taxId = '10000000000';
        this.phone = '02 8002 9590';
        this.street = '1 Wentworth St';
        this.suburb = 'Parramatta';
        this.state = 'NSW';
        this.postcode = '2150'
        this.fullAddress = 'Address: 1 Wentworth St Parramatta NSW 2150';
        this.logo = `${baseUrl}/images/workbuddy_full_logo_blue_preview.png`;
        this.branchNumber = `061-555`;
        this.accountNumber = `1234 5678`;

    }

}